import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

@Component({
    selector: 'app-gen-gmail-ad-non-eu-mobile-03',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './gmail-ad-non-eu-mobile-03.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gmail-ad-non-eu-mobile-03.component.scss'
})
export class GmailAdNonEuMobile03PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** Row count for the skeleton inbox filling out the list below the ad. */
  readonly inboxSkeletonRows = Array.from({ length: 2 });

  /** The uploaded creative for this set's inline thumbnail: prefers 1200x1200, falls back to 600x600, then any square. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /** Shown in place of the thumbnail when it hasn't been uploaded yet. */
  /** This placement's creative slot is the square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);
}
